import { get } from './requests'

export const getPresignedDocuments = key => id =>
  get(['loans', id, 'documents-url'], { key, transformPayload: true })

export const getSAPresignedDocuments = key => id =>
  get(['salary-advance', id, 'documents-url'], { key, transformPayload: true })
